import $ from "cash-dom";
import {validate} from "../systems/validate";
import {format} from "../systems/format";

export const postalCodeInputComponent = (root, {defaultValue} = {defaultValue: ''}) => {
    const $root = $(root);
    const validateCorrectIcon = $root.find('.validate-correct').get(0);
    const input = $root.find('input').get(0);

    input.value = defaultValue;

    const parseValue = format.postalCode;
    const formatValue = format.view.postalCode;

    const onInput = () => {
        const value = parseValue(input);
        input.value = formatValue(value);
        if (validateCorrectIcon)
            validateCorrectIcon.style.opacity = validate.postalCode()(value) ? '1' : '0';
    };

    input.oninput = onInput;
};
